// Customer Tab Start
export const TAB_DETAIL = "detail";
export const TAB_TEAM = "team";
export const TAB_PROJECTS = "projects";
export const CUSTOMER_SORTBY_ALPHABETICAL_A_Z = "Alphabetical A-Z";
export const CUSTOMER_SORTBY_RATING = "Rating";
// Customer Tab End
